import { Fragment, useState } from "react";
import Pagination from "react-js-pagination";
import useConfiguration from "../../hooks/useConfiguration";
import { archievedNotification, deleteTextNotificationData, getSMSDetails, sendAllSmsbtn, sendSMS, updateTextNotificationStatus } from "./action";
import moment from "moment";
import { useDispatch } from "react-redux";
import { Collapse } from "react-bootstrap";
import SMSModal from "../common/Modal/SMSModal";
import { toast } from "react-toastify";
import useSessionStorage from "../../hooks/useSessionStorage";
import './index.css';
import { getNotificationCounts } from '../NotificationHeader/action'
const Inbox = ({
  content,
  isOpen,
  toggle,
  removeTextNotifications,
  textNotificationStatusHandler,
  archievedNotificationHandler
}) => {

  const regex = /(<([^>]+)>)/ig;
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  // SMS state
  const [smsModalList, setSmsModalList] = useState([]);
  const [smsModalInd, setSmsModalInd] = useState(false);
  const [smsModalData, setSmsModalData] = useState({});
  const [smsModalGetData, setSmsModalGetData] = useState({ sms: "" });
  const [smsHistoryMainPageFlag, setSMSHistoryMainPageFlag] = useState(false);
  const [candidateName, setCandidateName] = useState('');

  // Show SMS Modal Box
  const showSmsModal = async (data) => {
    setCandidateName(data?.candidateName);
    if (smsModalInd) {
      setSmsModalList([]);
    } else {
      if (!!login?.verifiedPhoneNumber) {
        const params = {
          candidateUniqueId: data?.candidateUniqueId,
          employerMobileNumber: login.verifiedPhoneNumber,
          candidateMobileNumber: `${login.countryPhoneCode}${(data.candidatePhone)?.replace(/-/g, '')}`
        }
        const smsDetailsResult = await dispatch(
          getSMSDetails({
            url: `${config.baseUrl}/Messaging/get-sms-messages`, params
          }),
        );
        setSmsModalList(smsDetailsResult);
      } else {
        toast.error("SMS faciality not mapped to this employer.")
        return
      }
    }
    getSmsModalData("sms", "");
    setSmsModalData(data);
    setSmsModalInd((preVal) => !preVal);
  };

  // Save Single SMS Modal box
  const saveSmsModal = async () => {
    const requestBody = {
      candidateUniqueId: smsModalData.candidateUniqueId,
      messageBody: smsModalGetData.sms,
      ParentId: content?.messageTrackingId
    };
    await dispatch(
      sendSMS({
        url: `${config.baseUrl}/Messaging/send-sms-to-candidate`,
        params: requestBody,
      }),
    );
    setSMSHistoryMainPageFlag(false)
    showSmsModal();
  };

  // get Modal data
  const getSmsModalData = (index, value) => {
    setSmsModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // Send All for SMS
  const sendAllSms = () => {
    dispatch(
      sendAllSmsbtn('https://development.overturexl.com/DevMessagingApi/api/Messaging/sendSMS')
    );
    showSmsModal();
  };


  return (
    <>
      <SMSModal
        showModal={smsModalInd}
        handleClose={showSmsModal}
        data={smsModalData}
        handleSave={saveSmsModal}
        formData={smsModalGetData}
        handleForm={getSmsModalData}
        listData={smsModalList}
        sendAllSms={sendAllSms}
        groupSMSSaveFlag={false}
        candidateName={candidateName}
      />
            <tr>
              <td style={{fontSize:"0.85rem"}}>
                <div class="d-flex align-items-center ">
                  <span onClick={toggle} role="button" className="me-2">
                    {isOpen ? (
                      <i
                        class="fa fa-angle-down"
                        style={{ fontSize: "24px" }}
                      ></i>
                    ) : (
                      <i
                        onClick={() => {
                          if (content?.isRead !== 1) {
                            textNotificationStatusHandler({
                              status: 1,
                              notifyId: content?.messageTrackingId,
                              candidateUniqueId: content?.candidateUniqueId,
                              communicationType: content?.communicationType
                            });
                          }
                        }}
                        class="fa fa-angle-right"
                        style={{ fontSize: "24px" }}
                      ></i>
                    )}
                  </span>
                  <span style={{ width: '40px' }}>
                    {content?.isRead !== 1 && (
                      <span
                        className="text-center bg-danger text-white rounded-2 p-1 me-2 "
                        style={{ fontSize: "10px" }}
                      >
                        New
                      </span>
                    )}
                  </span>
                  {/* <span className="">
                 {content?.communicationType}
                </span> */}
                  <span className="d-flex flex-column">
                    <span>{content?.candidateName}</span>
                    <span>{content?.candidateEmail}</span>
                  </span>
                </div>
              </td>
              {/* <td className="col-2">
              <span className="d-flex flex-column">
                    <span>{content?.candidateName}</span>
                    <span>{content?.candidateEmail}</span>
                  </span>
              </td> */}
              <td  style={{ fontSize:"0.85rem" }}>
                {content?.subject}
              </td>
              <td style={{ maxWidth: '180px',fontSize:"0.85rem" }}
                className=" view-message clickable-row text-truncate">
                {
                  content?.message?.split(/\n/).map((line) => (
                    <Fragment key={line}>
                      {line.replace(regex, '')}
                    </Fragment>))
                }
              </td>
              <td style={{fontSize:"0.85rem"}}>
                {content?.messageDateTime}
              </td>
              <td style={{fontSize:"0.85rem"}}>
                {content?.fromCandidate && <span onClick={() => showSmsModal(content)} style={{ cursor: 'pointer', color: '#fff', fontSize: '24px' }} className="text_connection" ><i className="fa fa-commenting-o"></i></span>}
              </td>
              <td style={{fontSize:"0.85rem"}}>
                {content?.isRead === 1 ? (
                  <span
                    onClick={() =>
                      textNotificationStatusHandler({
                        status: 0,
                        notifyId: content?.messageTrackingId,
                        candidateUniqueId: content?.candidateUniqueId,
                        communicationType: content?.communicationType
                      })
                    }
                    style={{ cursor: "pointer" ,gap: "0.5rem"}}
                    className="d-flex align-items-center"
                  >
                    <i className="bi bi-envelope-open fa-lg text-primary"></i>
                    <span>Read</span>
                  </span>
                ) : (
                  <span
                    onClick={() =>
                      textNotificationStatusHandler({
                        status: 1,
                        notifyId: content?.messageTrackingId,
                        candidateUniqueId: content?.candidateUniqueId,
                        communicationType: content?.communicationType
                      })
                    }
                    style={{ cursor: "pointer" ,gap: "0.5rem"}}
                    className="d-flex align-items-center"
                  >
                    <i class="bi bi-envelope fa-lg text-primary"></i> 
                    <span>Mark as Read</span>
                  </span>
                )}
              </td>
              <td style={{fontSize:"0.85rem"}}>
              {
                  content?.isArchived ?  <span
                  style={{ gap: "0.5rem" }}
                  className="d-flex align-items-center"
                  role="button"
                  onClick={() => archievedNotificationHandler({status:0, notifyId:content?.messageTrackingId})}
                >
                  <i class="fa fa-archive fa-lg text-primary"></i> 
                  <span>Unarchive</span>
                </span> :  <span
                  style={{ gap: "0.5rem" }}
                  className="d-flex align-items-center"
                  role="button"
                  onClick={() => archievedNotificationHandler({status:1, notifyId:content?.messageTrackingId})}
                >
                  <i class="fa fa-archive fa-lg text-primary"></i> 
                  <span>Archive</span>
                </span>
                }
              </td>
              <td >
                <i
                  role="button"
                  style={{ cursor: "pointer", fontSize: "1rem" }}
                  onClick={() => removeTextNotifications(content.messageTrackingId)}
                  class="text-primary fe fe-trash-2"
                ></i>
              </td>
            </tr>

      {/* details */}
      <Collapse in={isOpen} className="content">
        <div className="row mt-3 ms-4">
          <span className="fw-bolder">
            <h4>Message Info</h4>
          </span>

          <div className="row">
            {
              content?.message?.split(/\n/).map((line) => (
                <Fragment key={line}>
                  {line.replace(regex, '')}
                  <br />
                </Fragment>))
            }
          </div>

        </div>
      </Collapse>
    </>
  );
};

// const Inbox = ({
//   content,
//   isOpen,
//   toggle,
//   removeTextNotifications,
//   textNotificationStatusHandler
// }) => {
//   return (
//     <div className="border-bottom">
//       <div className="table-responsive">
//         <table
//           className="table dataTable no-footer girdtable table-borderless"
//           role="grid"
//           aria-describedby="myTable_info"
//         >
//           <tbody>
//             <tr>
//               <td className="col-1">
//                 <div class="d-flex align-items-center ">
//                   <span onClick={toggle} role="button" className="me-2">
//                     {isOpen ? (
//                       <i
//                         class="fa fa-angle-down"
//                         style={{ fontSize: "24px" }}
//                       ></i>
//                     ) : (
//                       <i
//                         onClick={() => {
//                           if (!content?.isMessageRead) {
//                             textNotificationStatusHandler({
//                               status: true,
//                               readBy: content?.candidateInfo?.candidateUniqueId,
//                               notifyId: content?.messageId,
//                             });
//                           }
//                         }}
//                         class="fa fa-angle-right"
//                         style={{ fontSize: "24px" }}
//                       ></i>
//                     )}
//                   </span>
//                   {!content?.isMessageRead && (
//                     <span
//                       className="text-center bg-danger text-white rounded-2 p-1 me-2 "
//                       style={{ fontSize: "10px" }}
//                     >
//                       New
//                     </span>
//                   )}
//                       <span className="d-flex flex-column">
//                     <span>{content?.candidateName}</span>
//                     <span>{content?.candidateEmail}</span>
//                   </span>
//                 </div>
//               </td>
//               <td className="col-2">
//                 {content?.subject}
//               </td>
//               <td className="col-2">
//                 {content?.message}
//               </td>
//               <td className="col-2">
//                     {content?.receivedDateTime ? moment(content?.receivedDateTime ).format('MM-DD-YYYY HH:mm A') : ""}
//               </td>
//               {/* <td className="col-2">
//                 <span
//                   // onClick={() => {
//                   //   openChantWindow(
//                   //     content?.jobInfo?.shiftUniqueId,
//                   //     content?.candidateInfo?.candidateUniqueId
//                   //   );
//                   // }}
//                 >
//                   <i className="bi bi-reply fa-lg text-success"></i> Send a message
//                 </span>
//               </td> */}
//               <td className="col-2">
//                 {content?.isMessageRead ? (
//                   <span
//                     onClick={() =>
//                       textNotificationStatusHandler({
//                         status: false,
//                         readBy: content?.candidateInfo?.candidateUniqueId,
//                         notifyId: content?.messageId,
//                       })
//                     }
//                     style={{ cursor: "pointer" }}
//                   >
//                     <i className="bi bi-envelope-open fa-lg text-primary"></i>{" "}
//                     Read
//                   </span>
//                 ) : (
//                   <span
//                     onClick={() =>
//                       textNotificationStatusHandler({
//                         status: true,
//                         readBy: content?.candidateInfo?.candidateUniqueId,
//                         notifyId: content?.messageId,
//                       })
//                     }
//                     style={{ cursor: "pointer" }}
//                   >
//                     <i class="bi bi-envelope fa-lg text-primary"></i> Mark as
//                     Read
//                   </span>
//                 )}
//               </td>
//               <td className="col-1">
//                 <i
//                   style={{ cursor: "pointer", fontSize: "1rem" }}
//                   onClick={() => removeTextNotifications(content.messageId)}
//                   class="text-primary fe fe-trash-2"
//                 ></i>
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

const AccordianTable = (props) => {
  const { handlePageChange, currentPage, pageSize, totalCount, handlePageSize } = props;
  const [isOpen, setIsOpen] = useState(null);
  //   const [openMessaging, setOpenMessaging] = useState(false);
  //   const [chatData, setChatData] = useState([]);
  const [inboxParams, setInboxParams] = useState({
    webPageId: 0,
    shiftUniqueId: "",
    candidateUniqueId: "",
    employerUniqueId: "",
  });
  const config = useConfiguration();
  const dispatch = useDispatch();
  const storage = useSessionStorage();
  const login = storage.getItem("login");

  const toggleOpen = (id) => () => {
    setIsOpen((isOpen) => (isOpen === id ? null : id));
  };


  const textNotificationStatusHandler = ({ status, notifyId, candidateUniqueId, communicationType }) => {
    const textNotificationStatusParams = {
      "messageTrackingId": notifyId,
      "markAsMessageRead": status,
      communicationTypeEnum: communicationType,
      candidateUniqueId: candidateUniqueId,
      employerUniqueId: login?.employerUniqueId
    }

    dispatch(updateTextNotificationStatus({
      url: config.baseUrl,
      textNotificationStatusParams
    })).then(() => {
      setTimeout(() => {
        dispatch(getNotificationCounts(config.baseUrl))
      }, 1000)
    })
  };
  const archievedNotificationHandler = ({ status, notifyId}) => {
    const textNotificationStatusParams = {
      "messageTrackingId": notifyId,
      "isArchived": status,
    }
    dispatch(archievedNotification({
      url: config.baseUrl,
      textNotificationStatusParams
    })).then(() => {
      setTimeout(() => {
        dispatch(getNotificationCounts(config.baseUrl))
      }, 1000)
    })
  };

  const removeTextNotifications = textNotfifyId => {
    dispatch(deleteTextNotificationData({
      url: config.baseUrl,
      textNotfifyId
    }))
  }
  return (
    <div className="card">
      <div className="card-header">
        <div className="col-lg-4 col-md-4">
          <h5 className="card-title">Text Messages</h5>
        </div>
      </div>
      <div className="card-body">
        <div className="d-inline-flex align-items-center ">
          <label class="mb-0 pe-2">Show</label>
          <select
            name="myTable_length"
            class="form-control form-select"
            value={pageSize}
            aria-controls="myTable"
            onChange={(e) => handlePageSize(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
          <span className="Entries"> entries</span>
        </div>
        <div className="table-scrollable table-responsive">
          <table
            id="myTable"
            className="table dataTable girdtable no-footer scrollme"
            role="grid"
            aria-describedby="myTable_info"
          >
            <thead>
              <tr role="row">
                {props?.headerList.map((column) => (
                  <th
                    className="reset_start"
                    tabIndex="0"
                    aria-controls="myTable"
                    rowSpan="1"
                    colSpan="1"
                    style={{border:"none"}}
                  >
                    <div
                      className="d-flex gap-2"
                      style={{
                        height: "0px",
                        width: column?.width ? `${column?.width}px`:"",
                        maxWidth: column?.maxWidth ? `${column?.maxWidth}px`:"",
                      }}
                    >
                      <div style={{ visibility: "hidden" }} className="">
                        {column?.Header}
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
            {props.textNotificationData &&
          props.textNotificationData.length > 0 &&
          props.textNotificationData.map((item, index) => (
            <Inbox
              key={index}
              content={item}
              isOpen={isOpen === index}
              toggle={toggleOpen(index)}
              removeTextNotifications={removeTextNotifications}
              textNotificationStatusHandler={textNotificationStatusHandler}
              archievedNotificationHandler = {archievedNotificationHandler}
            />
          ))}
            </tbody>
          </table>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div
          className="dataTables_info ps-3"
          id="myTable_info"
          role="status"
          aria-live="polite"
        >
          Showing Page{" "}
          <strong>
            {currentPage} of {Math.ceil(totalCount / pageSize)}
          </strong>
        </div>
        <div class="pe-3 mb-4">
          <Pagination
            itemClass="page-item" // add it for bootstrap 4
            linkClass="page-link" // add it for bootstrap 4
            activePage={currentPage}
            itemsCountPerPage={pageSize}
            totalItemsCount={totalCount}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default AccordianTable;
